import { render, staticRenderFns } from "./textDecoration.vue?vue&type=template&id=696ac3a0&scoped=true&"
import script from "./textDecoration.vue?vue&type=script&lang=js&"
export * from "./textDecoration.vue?vue&type=script&lang=js&"
import style0 from "./textDecoration.vue?vue&type=style&index=0&id=696ac3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696ac3a0",
  null
  
)

export default component.exports